module.exports = __webpack_public_path__ + "static/media/1.b2064f48.svg";